export default __webpack_public_path__ + "d179ed66f5bc5897dd13ec38bab89dd6.otf";